module.exports = __webpack_public_path__ + "static/media/transit_pass.49f19fe4.svg";